import React from 'react'
import { Link } from 'react-router-dom'
import Footer_1 from '../../assets/images/svg/addres-icon-2.svg'
import Footer_2 from '../../assets/images/svg/mail-icon-2.svg'
import Footer_3 from '../../assets/images/svg/call-icon-2.svg'

const ContactFooter1 = () => {
    return (
        <>
            <div className="main-footer">
                <div className="contact-section-one">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="contact-left-one">
                                    <div className="heading-box">
                                        <span
                                            className="sub-title animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                        >
                                            Contact
                                        </span>
                                        <h2
                                            className="heading-title animate fadeInUp wow"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="200ms"
                                        >
                                            Get free business consultation Today
                                        </h2>
                                    </div>
                                    <p
                                        className="lead animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="400ms"
                                    >
                                        At uniqo, we are a renowned global consulting.
                                    </p>
                                    <ul
                                        className="contact-details-one animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <li>
                                            <img src={Footer_1} alt="icon" />
                                            <p>Old Westbury 256, New York 11201, United States</p>
                                        </li>
                                        <li>
                                            <img src={Footer_2} alt="icon" />
                                            <Link to="mailto:Uniqu@example.com">Uniqu@example.com</Link>
                                        </li>
                                        <li>
                                            <img src={Footer_3} alt="icon" />
                                            <Link to="tel:1-888-452-1505">1-888-452-1505</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div
                                    className="contact-form-one  animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                >
                                    <form action="#">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                                className="form-control"
                                                required=""
                                            />
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email"
                                                className="form-control"
                                                required=""
                                            />
                                        </div>
                                        <div className="form-group">
                                            <textarea
                                                name="message"
                                                placeholder="Message"
                                                rows={4}
                                                className="form-control"
                                                required=""
                                                defaultValue={""}
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-secondary btn-theme">
                                            Send +
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactFooter1
